import { type Dispatch } from 'redux';
import { showReportingDialog } from './ReportingDialog';

interface DetailsReportingDialogProps {
	/** The details model */
	model?: any;
	/** The Redux dispatcher function */
	dispatch: Dispatch<any>;
	/** The settings instance */
	settings: any;
	/** The application settings */
	sysSettings: any;
}

export function showDetailsReportingDialog(props: DetailsReportingDialogProps) {
	props.dispatch(
		showReportingDialog({
			module: props.settings.modu_title,
			folder: 'details',
			defaultParameters: [
				{ id: 'REPORT_DATA_ADAPTER', state: { value: props.sysSettings.report_dataadapter_path } },
				{ id: 'UID', state: { value: props.model[`${props.settings.modu_short}_uid`] } }
			]
		})
	);
}

export default { showDetailsReportingDialog };
